const API_URL = `${process.env.REACT_APP_API_URL}/v1/connect`;

exports.SIGNIN_URL = `${API_URL}/investor-sign-in`;
exports.SIGNUP_URL = `${API_URL}/investor-sign-up`;
exports.INVESTMENT_URL = `${API_URL}/investment`;
exports.FUND_INVESTMENT = `${API_URL}/fund-investment`;
exports.INVESTMENT_DETAIL_URL = (id) => `${API_URL}/investment-detail/${id}`;
exports.INVESTMENT_CATEGORY_URL = (data) => `${API_URL}/investment/${data}`;
